module.exports = __webpack_public_path__ + "static/media/badge.3fa72503.png";